/**
 * Copyright © 2017, Rezo Zero
 *
 * @file ClassFactory.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import DefaultPage from '../pages/DefaultPage'
import {AbstractBlock} from 'starting-blocks'
import HomePage from '../pages/HomePage'
import InterviewPage from '../pages/InterviewPage'
import TextBlock from '../blocks/TextBlock'

/**
 * Router mapper class.
 *
 * This class maps your `data-node-type` with your *ES6* classes.
 *
 * **You must define your own ClassFactory for each of your projects.**.
 */
export default class ClassFactory {
    /**
     * Returns an `AbstractPage` child class instance
     * according to the `nodeTypeName` or an `AbstractPage` as default.
     *
     * @param $cont
     * @param  {String}  nodeType
     * @param  {Router}  router
     * @param  {String}  context
     *
     * @return {AbstractPage}
     */
    getPageInstance (router, $cont, context, nodeType) {
        switch (nodeType) {
        case 'home':
            return new HomePage(router, $cont, context, nodeType)
        case 'interview':
            return new InterviewPage(router, $cont, context, nodeType)
        default:
            return new DefaultPage(router, $cont, context, nodeType)
        }
    }

    /**
     * Returns an `AbstractBlock` child class instance
     * according to the nodeTypeName or an AbstractBlock as default.
     *
     * Comment out the default case if you don’t want a default block to be instantiated
     * for each block.
     *
     * @param  {AbstractPage} page
     * @param  {jQuery}  $cont
     * @param  {String}  nodeType
     * @return {AbstractBlock}
     */
    getBlockInstance (page, $cont, nodeType) {
        switch (nodeType) {
        case 'textblock':
            return new TextBlock(page, $cont, nodeType)
        default:
            return new AbstractBlock(page, $cont, nodeType)
        }
    }
}



// WEBPACK FOOTER //
// ./webpack/js/factories/ClassFactory.js